export const ACTIVE_STEPS = [
  { label: "Enter Bid Details", value: 0 },
  { label: "Configure Bid", value: 1 },
  { label: "Configure Options", value: 2 },
  { label: "Review", value: 3 },
];

export const PLAN_STATUS = {
  DRAFT: "Draft",
  ACTIVE: "Active",
  INACTIVE: "Inactive",
};

export const AREA_COLUMNS = {
  LEFT: 0,
  RIGHT: 1,
};

export const ACTIVE_STEP = {
  DETAILS: 0,
  CONFIGURE: 1,
  OPTIONS: 2,
  REVIEW: 3,
};

export const OPTION_STATUS = {
  ADDED: "IsAdded",
  EXISTING: "IsExisting",
  REMOVED: "IsRemoved",
};

export const PLAN_TAB_VALUES = {
  SERIES: "series",
  COMMUNITIES: "communities",
};

export const PLAN_TABS = [
  { label: "Series", value: PLAN_TAB_VALUES.SERIES },
  { label: "Communities", value: PLAN_TAB_VALUES.COMMUNITIES },
];

export const PLAN_SERIES_TAB_VALUES = {
  ALL_PLANS: "all-bids",
  ACTIVE_PLANS: "active-bids",
  INACTIVE_PLANS: "inactive-bids",
};

export const PLAN_SERIES_TABS = [
  { label: "All", value: PLAN_SERIES_TAB_VALUES.ALL_PLANS },
  { label: "Active Bids", value: PLAN_SERIES_TAB_VALUES.ACTIVE_PLANS },
  { label: "Inactive Bids", value: PLAN_SERIES_TAB_VALUES.INACTIVE_PLANS },
];
